const actionTypeIdentifier = '3F6D1B42-AC98-4E27-9D2A-81C4E2F9B6F1';

export const getOutputRecord = `GET-OUTPUT-RECORD-${actionTypeIdentifier}`;
export const setOutputRecordPageSize = `SET-OUTPUT-RECORD-PAGE-SIZE-${actionTypeIdentifier}`;
export const setColSearchStr = `SET-COL-SEARCH-STR-${actionTypeIdentifier}`;
export const setColSort = `SET-COL-SORT-${actionTypeIdentifier}`;
export const setOutputRecordFilter = `SET-OUTPUT-RECORD-FILTER-${actionTypeIdentifier}`;
export const applyOutputRecordFilter = `APPLY-OUTPUT-RECORD-FILTER-${actionTypeIdentifier}`;
export const getAttachment = `GET-ATTACHMENT-${actionTypeIdentifier}`;
export const getOutputRecordId = `GET-OUTPUT-RECORD-ID-${actionTypeIdentifier}`;

